import apiClient from '../api';

export const getOrderDocuments = async (orderId, domainId) => {
    try {
        const response = await apiClient.get(`/api/orderdocuments/${orderId}/documents?domainId=${domainId}`);
        return response.data;
    } catch (error) {
        // console.error('Erreur lors de la récupération des documents de l\'ordre:', error);
        throw new Error('Impossible de charger les documents de l\'ordre');
    }
};



// Fonction pour ouvrir le document directement dans le navigateur
export const openOrderDocument = async (url, documentName) => {
    try {
        // Vérifier si c'est un PDF pour l'ouvrir dans un nouvel onglet
        if (url.toLowerCase().includes('.pdf') || documentName.toLowerCase().includes('.pdf')) {
            window.open(url, '_blank', 'noopener,noreferrer');
        } else {
            // Pour les images et autres documents, ouvrir dans un nouvel onglet
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    } catch (error) {
        // console.error('Erreur lors de l\'ouverture du document:', error);
        throw new Error('Impossible d\'ouvrir le document');
    }
};

// Fonction pour télécharger le document
export const downloadOrderDocument = async (url, fileName) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName || 'document-ordre';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        // console.error('Erreur lors du téléchargement:', error);
        throw new Error('Impossible de télécharger le document');
    }
};